<template>
  <div class="content">
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-blue">
        <!-- <md-icon>perm_identity</md-icon> -->
        <div class="card-icon user-avatar">
          <img-with-fallback :src="account.avatar" alt="User picture" />
        </div>
        <h3 class="title">
          {{
            `${account.treatment} ${account.firstName} ${account.lastName} ${account.secondLastName}`
          }}
          ({{ account.username }})
        </h3>
      </md-card-header>
      <md-card-content class="md-layout md-alignment-space-between">
        <div class="md-layout-item md-size-40 md-xsmall-size-100">
          <md-chip
            class="md-caption md-success"
            :key="group.name"
            v-for="group in account.groups"
          >
            <strong> Grupo: </strong>
            {{ group.name }}
          </md-chip>
        </div>
      </md-card-content>
      <md-card-actions class="md-layout md-alignment-space-around">
        <span class="md-layout-item md-size-10"></span>
        <md-field class="md-layout-item" md-clearable>
          <md-icon> extension </md-icon>
          <label for="search"> Filtrar permisos </label>
          <md-input
            :value="permissionFilter"
            @input="updateSearchValue"
            md-clearable
          >
          </md-input>
          <md-icon> search </md-icon>
        </md-field>
        <md-button
          class="md-simple md-primary md-layout-item"
          :to="{
            name: 'Perfil de usuario',
          }"
        >
          <md-icon> person_pin </md-icon>
          Volver a Perfil
        </md-button>
      </md-card-actions>
    </md-card>

    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-100">
        <user-permissions-card
          card-title="Permisos de Sistema"
          :resource-permissions="filteredPermissions"
        >
          <md-table-cell
            slot="cell"
            slot-scope="{ data, permissions: resPerm }"
          >
            <md-content class="md-scrollbar">
              <div class="md-layout md-alignment-space-between md-gutter">
                <div
                  v-for="(actions, resource) in resPerm"
                  class="md-layout-item"
                >
                  <span class="md-caption">{{ resource }}</span>
                  <p>
                    <template
                      v-for="(enabled, action) in actions"
                      v-if="enabled"
                    >
                      <md-icon :key="action" v-if="ACTION_ICONS[action]">
                        {{ action | actionFilter }}
                      </md-icon>
                      <strong :key="action" class="md-body-1" v-else>
                        {{ action }}
                      </strong>
                    </template>
                  </p>
                </div>
              </div>
            </md-content>
          </md-table-cell>
        </user-permissions-card>
      </div>
    </div>
  </div>
</template>

<script>
  import UserCard from './UserProfileComponents/UserCard'
  import UserPermissionsCard from './UserProfileComponents/UserPermissionsCard'
  import { debounce } from 'lodash'

  import { mapState } from 'vuex'

  const MORE_LABEL = 'Otros'

  const CAN_LABEL = 'Acciones'

  const ACTION_ICONS = {
    add: 'add',
    view: 'visibility',
    change: 'edit',
    delete: 'close'
  }

  /**
   * User Group Permissions - An overview of the user's system permissions
   * @author Virgilio Vázquez J. <virgilio.vazquez@jbge.com.mx>
   * @version 0.6
   **/
  export default {
    components: {
      UserCard,
      UserPermissionsCard
    },

    computed: {
      ...mapState(["account"]),
      filteredPermissions() {
        const { groupPermissions: permissions } = this.account
        const { permissionFilter: rawFilter } = this
        const permissionFilter = rawFilter && new RegExp(rawFilter, "i")

        if (!permissionFilter) {
          return permissions
        } else {
          return Object.fromEntries(
            Object.entries(permissions)
              // .map(([ label, permissions ]) => [ label, permissions, permissions ])
              .map(([ label, permissions ]) => [
                label,
                // Filter model permissions
                Object.fromEntries(
                  Object.entries(permissions)
                    .filter(([ model ]) => model.match(permissionFilter)),
                ),
                permissions
              ])
              .map(([ label, appPermissionsResults, permissions ]) => (
                label.toLowerCase().match(permissionFilter)
                ? [ label, permissions ]
                : [ label, appPermissionsResults ]
              ))
              .filter(([ label, permissions  ]) => (
                Object.keys(permissions).length > 0
              ))
          )
        }
      }
    },

    data() {
      return {
        permissionFilter: null,
        ACTION_ICONS
      }
    },
    methods: {
      updateSearchValue: debounce(function (value) {
        this.permissionFilter = value
      }, 500)
    },

    filters: {
      actionFilter: (action) => ACTION_ICONS[action] || 'close'
    }
  }
</script>
<style lang="scss" scoped>
.text-right {
  display: flex;
}

.user-avatar img {
  border-radius: 100%;
  max-width: 48px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/UserGroupPermissions.vue